import React, { useContext, useEffect, useState } from "react";
import { Button, Stack, TextField, Tooltip, Typography } from "@mui/material";
import { StringObj } from "../../../../../../../type";
import { DndContext, closestCenter, DragEndEvent } from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { QuestionsContext } from "../../../../../../../provider/MyContexts";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import { AiCommands } from "./OptionArea";
import { ItemHeaderArea } from "./ItemHeader";
import { useItemHeader } from "./useItemHeader";
import { ClearButton } from "../../../../../components/MyIconButton";

type Props = {
  onChange: (options: object[]) => void;
  handleDelete: (index: number) => void;
  isMatrix?: boolean;
};

function SortableItem({ item, index }: { item: StringObj; index: number }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  const { updateOptionValue } = useContext(QuestionsContext);

  const [text, setText] = useState<string>("");

  function handleChangeText(e: React.ChangeEvent<HTMLInputElement>) {
    // e.preventDefault();
    // e.stopPropagation();
    setText(e.target.value);
  }

  useEffect(() => {
    setText(item.text);
  }, [item.text]);

  const isExclusive = item.exclusive && item.exclusive == "排他";

  return (
    <Stack ref={setNodeRef} style={style} marginX={0.5} flex={1}>
      <Stack
        direction={"row"}
        spacing={0.5}
        alignItems={"center"}
        justifyContent={"center"}
        marginY={0.5}
        padding={0.25}
        sx={{
          border: "1px solid transparent",
          ":hover": {
            border: "1px solid #333",
            borderRadius: 1,
          },
        }}
        // {...attributes}
        // {...listeners}
        flex={1}
      >
        <div {...attributes} {...listeners} style={{ cursor: "grab" }}>
          <DragHandleIcon fontSize="small" />
        </div>
        <TextField
          value={text}
          label={`${index + 1}`}
          size="small"
          sx={{ flex: 1 }}
          onChange={handleChangeText}
          onBlur={(e) => {
            e.preventDefault();
            e.stopPropagation();
            updateOptionValue(item.itemId, text, "text");
          }}
        />
        {/* todo: */}
        {/* ランダム設定次第でテキストフィールド表示 */}
        <Tooltip title={"排他"}>
          <Button
            variant="text"
            size="small"
            disabled
            sx={{
              width: "32px",
              aspectRatio: "1 / 1",
              minWidth: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "4px",
            }}
          >
            <DoNotDisturbIcon
              sx={{
                color: isExclusive ? "primary.main" : "disabled",
              }}
            />
          </Button>
        </Tooltip>
      </Stack>
    </Stack>
  );
}

export default function SortableOptions(props: Props) {
  const { onChange, handleDelete, isMatrix } = props;

  const { selectedQuestion } = useContext(QuestionsContext);

  const optionLength = selectedQuestion.options.length;
  const { headersLocal, addHeader, deleteHeader, handleChangeHeader } = useItemHeader();

  const handleDragEnd = (event: DragEndEvent) => {
    const { active, over } = event;
    if (!over || active.id === over.id) return;

    const oldIndex = optionItems.findIndex((item) => item.id === active.id);
    const newIndex = optionItems.findIndex((item) => item.id === over.id);
    const reordered = arrayMove(optionItems, oldIndex, newIndex);
    onChange(reordered);
  };

  const optionItems: any[] = selectedQuestion.options.map((item, index) => ({
    ...item,
    id: `${item.text}-${index}`, // ユニークID
    text: item.text,
  }));

  const handleAdd = () => {
    onChange([
      ...optionItems,
      {
        id: `${""}-${optionItems.length}`, // ユニークID
        text: "",
      },
    ]);
  };

  return (
    <Stack>
      {isMatrix ? (
        <Typography flex={1} variant="heading_XS" fontWeight={600} marginBottom={1}>
          選択肢・入力欄
        </Typography>
      ) : (
        <></>
      )}
      <AiCommands handleAdd={handleAdd} area={"options"} handleAddHeader={addHeader} />
      <Stack direction={"row"}>
        <ItemHeaderArea
          headers={headersLocal}
          optionLength={optionLength}
          deleteHeader={deleteHeader}
          handleChangeHeader={handleChangeHeader}
        />
        <DndContext collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
          <SortableContext
            strategy={verticalListSortingStrategy}
            items={optionItems.map((item) => item.id)}
          >
            <Stack width={"100%"} flex={1}>
              {optionItems.map((item, index) => {
                return (
                  <Stack
                    marginX={1}
                    direction={"row"}
                    spacing={0.1}
                    key={item.id}
                    alignItems={"center"}
                    justifyContent={"center"}
                    width={"100%"}
                  >
                    <SortableItem key={item.id} item={item} index={index} />
                    <ClearButton onClick={() => handleDelete(index)} />
                    {/* <Button
                      variant="text"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleDelete(index);
                      }}
                      sx={{
                        width: "32px",
                        aspectRatio: "1 / 1",
                        minWidth: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "4px",
                      }}
                    >
                      <Clear />
                    </Button> */}
                  </Stack>
                );
              })}
            </Stack>
          </SortableContext>
        </DndContext>
      </Stack>
    </Stack>
  );
}
